import { render, staticRenderFns } from "./BotoneraSimple.vue?vue&type=template&id=23e496cb"
import script from "./BotoneraSimple.vue?vue&type=script&lang=js"
export * from "./BotoneraSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports